export default function JoinCTA() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
          加入<strong className="text-primary-500">韩漫屋</strong>大家庭
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-md mx-auto">
          与200万+读者一起，发现更多精彩韩漫
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          开始阅读 <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}